import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';

function About() {
  return (
    <div className="min-h-screen bg-white font-quicksand">
      <SEO
        title="About Us"
        description="Learn about StudyPass RDH, the NBDHE board exam prep platform built by a registered dental hygienist to help students pass with confidence."
        path="/about"
      />
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-study-pink to-study-teal py-16 px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-study-black mb-4">
          About StudyPass
        </h1>
        <p className="text-xl text-study-black max-w-2xl mx-auto">
          Helping future dental hygienists pass their boards with confidence
        </p>
      </div>

      {/* Meet the Founder Section */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="flex flex-col md:flex-row items-center gap-10">
          {/* Founder Photo */}
          <img
            src="/Josie.jpg"
            alt="Josie - Founder of StudyPass"
            className="w-64 h-64 rounded-full object-cover flex-shrink-0 border-4 border-study-teal shadow-lg"
          />

          {/* Bio */}
          <div>
            <h2 className="text-3xl font-bold text-study-black mb-4">
              Meet the Founder
            </h2>
            <p className="text-study-black text-lg mb-4">
              Hi! I'm <span className="font-bold">Josie</span>, a registered dental hygienist and the creator of StudyPassRDH.
            </p>
            <p className="text-study-black mb-4">
              When I was preparing for my board exams, I spent countless hours studying textbooks, writing notes, and writing my own practice questions, wishing there was one platform that
              had everything I needed at a price I could pay. 
            </p>
            <p className="text-study-black mb-4">
              That's why I created StudyPassRDH—the all-in-one study resource I wish I had.
              I love helping dental hygiene students reach their dreams of becoming a registered dental hygienist by successfully passing their boards with confidence. I'm so glad you're here and look forward to studying together!
            </p>
          </div>
        </div>
      </div>

      {/* Mission Section */}
      <div className="bg-study-yellow py-16 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-study-black mb-6">
            Our Mission
          </h2>
          <p className="text-xl text-study-black max-w-3xl mx-auto">
            To empower dental hygiene students with the tools, resources, and confidence
            they need to successfully pass their board exams and launch thriving careers as registered dental hygienists
          </p>
        </div>
      </div>

      {/* What Makes Us Different */}
      <div className="max-w-6xl mx-auto px-6 py-16">
        <h2 className="text-3xl font-bold text-study-black text-center mb-12">
          What Makes StudyPass Different
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <FeatureCard
            icon="📚"
            title="Comprehensive Content"
            description="Thousands of practice questions, videos, study guides, and flashcards covering every topic on the board exams."
          />
          <FeatureCard
            icon="🎯"
            title="Created by an RDH"
            description="Developed by a registered dental hygienist who understands exactly what you need to succeed."
          />
          <FeatureCard
            icon="📊"
            title="Track Your Progress"
            description="Monitor your improvement with detailed analytics and identify areas that need more attention."
          />
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-study-teal to-study-pink py-16 px-6 text-center">
        <h2 className="text-3xl font-bold text-study-black mb-4">
          Ready to Start Studying?
        </h2>
        <p className="text-study-black text-lg mb-8 max-w-2xl mx-auto">
          Join thousands of dental hygiene students who are using StudyPass to prepare for their boards.
        </p>
        <Link
          to="/SignUp"
          className="inline-block bg-study-yellow text-study-black font-bold text-lg py-4 px-8 rounded-full hover:bg-white transition-all transform hover:scale-105 shadow-lg"
        >
          Get Started Free
        </Link>
      </div>

      {/* Contact Info */}
      <div className="max-w-4xl mx-auto px-6 py-12 text-center">
        <h3 className="text-2xl font-bold text-study-black mb-4">
          Questions?
        </h3>
        <p className="text-study-black">
          Reach out anytime at{' '}
          <a
            href="mailto:support@studypassrdh.com"
            className="text-study-teal font-bold hover:text-study-pink transition-all"
          >
            support@studypassrdh.com
          </a>
        </p>
      </div>
    </div>
  );
}

function FeatureCard({ icon, title, description }) {
  return (
    <div className="bg-white rounded-2xl shadow-md p-6 text-center hover:shadow-xl transition-all">
      <div className="text-5xl mb-4">{icon}</div>
      <h3 className="text-xl font-bold text-study-black mb-3">{title}</h3>
      <p className="text-study-black">{description}</p>
    </div>
  );
}

export default About;
